import React from 'react';
import classes from './index.module.css';

const LoadingPage = () => {
    return (
        <>
            <div className={classes.body}>
                <div className={classes['cs-loader']}>
                    <div className={classes['cs-loader-inner']}>
                        <label>●</label>
                        <label>●</label>
                        <label>●</label>
                        <label>●</label>
                        <label>●</label>
                        <label>●</label>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoadingPage;